
import router from '../pc/router'
import install from '../pc';
import "../assets/styles/pc/index.scss";

!function (global) {
  Vue.use(install);
  global.$platformRouter.pc.push(...router)
}(dsf.global || (dsf.global = {}))